import { Box, Button, Divider, Grid, IconButton, Modal, Stack, TextField, Typography } from '@mui/material'
import React from 'react'
import { useTranslation } from 'react-i18next';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import { useForm } from '../../../hooks';
import { useDispatch, useSelector } from 'react-redux';
import { NumberInput } from '../NumberInput';
import { style } from '../../../helpers/editStyle';
import { DateInput } from '../DateInput';
import { toEnglishDate } from '../../../helpers/dateFormat';
import { unSelectFundDistribution } from '../../../store/fundDistribution/fundDistributionSlice';
import { createDivestmentFund } from '../../helpers/divestmentFund';
import { numberFormat } from '../../../helpers/numberFormat';

export const CreateDivestmentLP = ({ setHidden, setReloadData }) => {

    const { t } = useTranslation('global');
    const { dataToAction } = useSelector(state => state.fundDistribution)
    const date = new Date();
    const options = { day: '2-digit', month: '2-digit', year: 'numeric' };
    const actualDate = date.toLocaleDateString("es-ES", options);
    const sharesAvailable = (dataToAction?.amount / dataToAction?.participationValuation);

    const dispatch = useDispatch();
    const [formValues, handleInputChange, reset] = useForm({ divestmentDate: toEnglishDate(actualDate), divestmentParticipation: '', salesPrice: '', participationValuation: '' });

    const { divestmentDate, divestmentParticipation, salesPrice, participationValuation } = formValues;

    const handleCancel = () => {
        reset()
        dispatch(unSelectFundDistribution())
        setHidden(false)
    }
    const onSubmit = async(e) => {
        e.preventDefault();
        setHidden(false)
        await createDivestmentFund({ investmentDate: dataToAction.investmentDate, divestmentDate, amount: dataToAction.amount, participationValuation: dataToAction.participationValuation || participationValuation, divestmentParticipation, salesPrice, fundDistributionId: dataToAction.id, fundId: dataToAction.fundId }, t('divestment.successCreateMsg'), t('divestment.errorMsg'))
        setReloadData(prevState => !prevState)
    }

    return (
        <Modal
            open={true}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
            sx={{ zIndex: 9999 }}
        >
            <Box sx={style}>
                <Stack direction='row' justifyContent='space-between' alignItems='baseline' sx={{ height: '50px' }}>
                    <Typography color='primary' marginBottom='10px' variant='h5' fontWeight={700}>{t('divestment.divest')}</Typography>
                    <IconButton color='primary' onClick={handleCancel}>
                        <CloseRoundedIcon />
                    </IconButton>
                </Stack>
                <form onSubmit={onSubmit} style={{ padding: '10px 5px', display: 'flex', flexDirection: 'column', justifyContent: 'space-around' }}>
                    <Stack sx={{ height: 'calc(70vh - 200px)', overflowY: 'auto', paddingBottom: '10px', paddingRight: '20px' }}>

                        <Stack direction='column' width='100%' gap={0}>
                            <DateInput name={divestmentDate} title='divestmentDate' handleInputChange={handleInputChange} translation='divestmentDate' required={true} />
                        </Stack>

                        {
                            dataToAction.investmentType === 'Ampliación Capital' ?
                                <Grid container direction='row' width='100%' >
                                    <Grid item xs={12} padding='0 5px'>
                                        <Typography variant='overline' color='secondary'>{t(`number.divestmentParticipation`)}</Typography>
                                        <TextField
                                            fullWidth
                                            name='divestmentParticipation'
                                            size="small"
                                            variant="outlined"
                                            value={divestmentParticipation}
                                            onChange={handleInputChange}
                                            required={true}
                                            type='number'
                                            InputProps={{ inputProps: { min: 0, step: 'any', max: sharesAvailable } }}
                                            label={`${numberFormat(sharesAvailable)} ${t('divestment.available')}`}
                                        />
                                    </Grid>
                                </Grid>
                                :
                                <>
                                    <Grid container direction='row' width='100%' >
                                        <Grid item xs={12} padding='0 5px'>
                                            <NumberInput translation='salesPrice' name={participationValuation} title='participationValuation' handleInputChange={handleInputChange} required={true} />
                                        </Grid>
                                    </Grid>
                                    {
                                        (participationValuation !== '' && participationValuation !== '0') &&
                                        <Grid container direction='row' width='100%' >
                                            <Grid item xs={12} padding='0 5px'>
                                                <Typography variant='overline' color='secondary'>{t(`number.divestmentParticipation`)}</Typography>
                                                <TextField
                                                    fullWidth
                                                    name='divestmentParticipation'
                                                    size="small"
                                                    variant="outlined"
                                                    value={divestmentParticipation}
                                                    onChange={handleInputChange}
                                                    required={true}
                                                    type='number'
                                                    InputProps={{ inputProps: { min: 0, step: 'any', max: (dataToAction?.amount / participationValuation).toFixed(2) } }}
                                                    label={`${(dataToAction?.amount / participationValuation).toFixed(2)} ${t('divestment.available')}`}
                                                />
                                            </Grid>
                                        </Grid>
                                    }
                                </>
                        }

                        <Grid container direction='row' width='100%' >
                            <Grid item xs={12} padding='0 5px'>
                                <NumberInput translation='salesPrice' name={salesPrice} title='salesPrice' handleInputChange={handleInputChange} required={true} />
                            </Grid>
                        </Grid>

                    </Stack>

                    <Stack sx={{ heigth: '80px' }}>
                        <Divider sx={{ margin: '30px 0px 15px 0px' }} />

                        <Grid container direction='row' width='100%' >
                            <Grid item xs={12} md={6} padding='0 5px'>
                                <Button fullWidth onClick={handleCancel} variant="text">{t("createPassword.cancelButton")}</Button>
                            </Grid>
                            <Grid item xs={12} md={6} padding='0 5px'>
                                <Button fullWidth type='submit' variant="contained">{t("createPassword.principalButton")}</Button>
                            </Grid>
                        </Grid>
                    </Stack>
                </form>

            </Box>
        </Modal>
    )
}